import Vue from "vue";
import store from "../store/index";
import Router from "vue-router";
// import HelloWorld from "@/components/HelloWorld";

Vue.use(Router);

var npush = Router.prototype.push;
Router.prototype.push = function (loction) {
  return npush.call(this, loction).catch((err) => err);
};

const router = new Router({
  routes: [
    {
      path: "/404",
      component: () => import("@/views/404"),
      hidden: true,
    },
    {
      path: "/",
      component: () => import("@/views/index"),
    },
    {
      path: "/guide",
      component: () => import("@/views/guide"),
    },
    {
      path: "/download",
      component: () => import("@/views/download"),
    },
    {
      path: "/notification",
      component: () => import("@/views/notification/notification"),
    },
    {
      path: "/notificationDetail",
      component: () => import("@/views/notification/detail"),
    },
    {
      path: "/news",
      component: () => import("@/views/news/news"),
    },
    {
      path: "/newsDetail",
      component: () => import("@/views/news/detail"),
    },
    {
      path: "/personal",
      component: () => import("@/views/personal/personal"),
    },
    {
      path: "/personalDetail",
      component: () => import("@/views/personal/detail"),
    },
    {
      path: "/personalVDetail",
      component: () => import("@/views/personal/detail2"),
    },
    {
      path: "/competition",
      component: () => import("@/views/competition/competition"),
    },
    {
      path: "/sign",
      component: () => import("@/views/competition/sign"),
    },
    {
      path: "/login",
      component: () => import("@/views/login/login"),
    },
    {
      path: "/forget",
      component: () => import("@/views/login/forget"),
    },
    {
      path: "/register",
      component: () => import("@/views/login/register"),
    },
    {
      path: "/register1",
      component: () => import("@/views/login/register1"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // console.log("tototo", to);
  // if (!localStorage.getItem("lang")) {
  //   localStorage.setItem("lang", 2);
  // }
  // store.commit("SET_LANG", localStorage.getItem("lang") || 2);
  //每次进入滚动到页面顶部
  if (!to.query.navindex) {
    window.scrollTo({
      top: 0,
    });
  }
  if (to.path !== from.path) {
    // 路由切换，但不刷新页面
    next();
  } else {
    // 正常导航
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js